export default class Popup {
    /**
     * Create a new popup appending it to the given element
     * @param {HTMLElement} parent Element to append popup to
     */
    constructor(parent) {
        const element = new DOMParser()
            .parseFromString(`
            <div class="popup">
                <!-- class name can't be 'close' due to bootstrap css -->
                <div class="close-btn">[x]</div>
                <div class="body" >
            </div>`, 'text/html')
            .querySelector('.popup');

        this.element = element;

        element.querySelector('.close-btn')
            .addEventListener('click', _ => this.close());

        parent.appendChild(element);
    }

    display(){
        this.element.classList.add('visible');
        return this;
    }

    setText(text){
        this.element.querySelector('.body')
            .innerText = text;
        return this;
    }

    moveTo(x, y){
        this.element.style.top = y + 'px';
        this.element.style.left = x + 'px';
        return this;
    }

    close(){
        this.element.classList.remove('visible');
        return this;
    }

    static BuildBodyTextFromNode(node){
        let bodyText = `${node.node.type}`;

        if(node.children && node.children.length > 0) {
            let ntotal = node.node.total,
                ctotal = 0;
            bodyText += "\r\n\r\nUitgaand:";
            node.children.forEach(c => {
                ctotal += c.node.total;
                let per = ntotal == 0 ? 0 : Math.round(c.node.total / (ntotal / 100))
                bodyText += `\r\n\t* ${per}% ${c.node.type}`;

            })
            let per = ntotal == 0 ? 0 : Math.round((ntotal-ctotal) / (ntotal / 100))
            bodyText += `\r\n${per}% rest`;
        } else if (node.total > 0)  {
            bodyText += `\r\n$100% rest`;
        }

        return bodyText;
    }
}